const WORK_RIGHTS = 'workRights';

const FILEUPLOAD_CATEGORY = {
    FILEUPLOAD: 0,
    DOCSIGNATURE: 1,
    RIGHT_TO_WORK: 2
}

function getFileUploadCategory(fieldName) {
    if (fieldName.includes(WORK_RIGHTS)) {
        return FILEUPLOAD_CATEGORY.RIGHT_TO_WORK
    }
    return FILEUPLOAD_CATEGORY.FILEUPLOAD
}

export {
    FILEUPLOAD_CATEGORY,
    getFileUploadCategory
}
